module.exports = __webpack_public_path__ + "static/img/photo02.e6eb528.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Tokyo/photo02.jpg
// module id = +DL8
// module chunks = 0